<section class="admin-servers">
  <app-page-header
    title="Configuración de servidores"
    subtitle="Contexto de tenant global y listado de empresas registradas en el sistema."
    icon="Server"
  />

  @if (!canManage()) {
    <div class="admin-servers__denied card-like">
      <p>Solo el superadministrador puede acceder a la configuración de servidores.</p>
    </div>
  } @else {
    @if (error()) {
      <app-vault-page-alert
        type="error"
        title="Error"
        [message]="error()"
        (closed)="error.set(null)"
      />
    }
    @if (info()) {
      <app-vault-page-alert
        type="success"
        title="Listo"
        [message]="info()"
        (closed)="info.set(null)"
      />
    }

    <article class="admin-servers__card card-like">
      <h2>Contexto global de tenant</h2>
      <p class="admin-servers__hint">
        UUID usado en cabeceras `X-Tenant-ID` para ingesta y otros módulos cuando no hay tenant en sesión.
      </p>
      <div class="admin-servers__field">
        <lib-input label="Tenant UUID" [value]="tenantId()" (valueChange)="tenantId.set($event)" />
      </div>
      <div class="admin-servers__actions">
        <lib-button variant="primary" type="button" (clicked)="saveContext()">Guardar contexto</lib-button>
        <lib-button variant="secondary" type="button" (clicked)="clearContext()">Limpiar</lib-button>
        <lib-button variant="secondary" type="button" prefixIcon="RefreshCcw" [loading]="loading()" (clicked)="reload()">
          Actualizar
        </lib-button>
        <a class="admin-servers__link" routerLink="/layout/vault/admin/tenants">Ir a Gestión de Empresas</a>
      </div>
    </article>

    <article class="admin-servers__card card-like">
      <h2>Empresas registradas</h2>
      <p class="admin-servers__hint">
        La configuración detallada de URL de servidor y credenciales por empresa se gestiona en Gestión de
        Empresas cuando el API lo exponga. Aquí se muestra el inventario actual.
      </p>
      @if (loading()) {
        <lib-skeleton variant="rectangle" [height]="'120px'" />
      } @else if (tableData().length === 0) {
        <lib-empty icon="Building" message="Sin empresas" description="No hay empresas registradas." />
      } @else {
        <lib-table [config]="tableConfig()" [data]="tableData()" [loading]="loading()" />
      }
    </article>
  }
</section>
